import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Persons.css";

function Persons({ person }) {
  const navigate = useNavigate();
  const location = useLocation(); // Get the location object from React Router

  useEffect(() => {
    // Check if the state contains the scrollToSection value
    if (location.state && location.state.scrollToSection) {
      const sectionId = location.state.scrollToSection;

      const sectionElement = document.getElementById(sectionId);

      // If the section element exists, scroll to it
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]); // Re-run the effect when the location changes
  return (
    <div className="person-container" id="person-section">
      <div className="person-card-container">
        {person.map((person) => {
          const personSlug = person.name.toLowerCase().replace(/\s+/g, "-"); // Convert name to slug format

          return (
            <div
              key={person.id}
              className="person-card-item"
              onClick={() =>
                navigate(`/person/${personSlug}`, { state: person })
              }
            >
              <div className="personimage">
                <img
                  src={
                    process.env.REACT_APP_BACKEND_URL_IMAGES + person.imageUrl
                  }
                  alt={person.name}
                />
              </div>
              <div className="signature">
                <img
                  src={
                    process.env.REACT_APP_BACKEND_URL_IMAGES + person.signature
                  }
                  alt={person.name}
                />
              </div>
              <p className="personPosition">{person.position}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Persons;
